import { Card } from '@/components/atoms/Card';
import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';

import styles from './TaskCard.module.scss';

export default function TaskCardSkeleton() {
    return (
        <Card radius="sm" className={styles.card}>
            <div className={styles.cardHeader}>
                <SkeletonBox width={40} height={40} borderRadius="50%" />
                <div className={styles.cardBody}>
                    <div className={styles.titleRow}>
                        <SkeletonBox width="55%" height={18} />
                    </div>
                    <SkeletonBox width="85%" height={30} />
                </div>
            </div>
            <div className={styles.separator} />
            <div className={styles.footer}>
                <SkeletonBox width={140} height={14} />
                <div className={styles.footerActions}>
                    <SkeletonBox width={100} height={38} />
                </div>
            </div>
        </Card>
    );
}
